import { render } from "./JoinConferenceButton.vue?vue&type=template&id=404424c3&scoped=true&ts=true&lang=pug"
import script from "./JoinConferenceButton.vue?vue&type=script&lang=ts"
export * from "./JoinConferenceButton.vue?vue&type=script&lang=ts"

import "./JoinConferenceButton.vue?vue&type=style&index=0&id=404424c3&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./JoinConferenceButton.vue?vue&type=custom&index=0&blockType=i18n&locale=en"
if (typeof block0 === 'function') block0(script)
import block1 from "@/locale/components/conference/es-joinconferencebutton.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Ftarball%2Fsrc%2Fcomponents%2Fconference%2FJoinConferenceButton.vue&locale=es"
if (typeof block1 === 'function') block1(script)


import exportComponent from "/tarball/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-404424c3"]])

export default __exports__